import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type JourneyStep = 
  | 'COMPANY_SETUP'
  | 'VISION_WORKSHOP'
  | 'BRAND_DEVELOPMENT'
  | 'OPERATIONS_SETUP'
  | 'COMPLETE';

interface JourneyState {
  currentStep: JourneyStep;
  completedSteps: JourneyStep[];
  progress: number;
  setCurrentStep: (step: JourneyStep) => void;
  completeStep: (step: JourneyStep) => void;
  getNextStep: () => JourneyStep | null;
}

const JOURNEY_STEPS: JourneyStep[] = [
  'COMPANY_SETUP',
  'VISION_WORKSHOP',
  'BRAND_DEVELOPMENT',
  'OPERATIONS_SETUP',
  'COMPLETE'
];

export const useJourneyStore = create<JourneyState>()(
  persist(
    (set, get) => ({
      currentStep: 'COMPLETE',
      completedSteps: ['COMPANY_SETUP', 'VISION_WORKSHOP', 'BRAND_DEVELOPMENT', 'OPERATIONS_SETUP'],
      progress: 100,

      setCurrentStep: (step) => set({ currentStep: step }),

      completeStep: (step) => set((state) => {
        const newCompletedSteps = [...state.completedSteps, step];
        const progress = (newCompletedSteps.length / (JOURNEY_STEPS.length - 1)) * 100;
        
        return {
          completedSteps: newCompletedSteps,
          progress,
          currentStep: get().getNextStep() || 'COMPLETE'
        };
      }),

      getNextStep: () => {
        const currentIndex = JOURNEY_STEPS.indexOf(get().currentStep);
        return JOURNEY_STEPS[currentIndex + 1] || null;
      }
    }),
    {
      name: 'journey-storage'
    }
  )
);